import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider, Spin, theme } from 'antd';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MenuProvider } from './context/MenuContext';
import AppLayout from './components/AppLayout';
import MenuEditor from './pages/MenuEditor';
import QRCode from './pages/QRCode';
import PublicMenu from './pages/PublicMenu';
import Login from './pages/Login';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, isLoading } = useAuth();
  if (isLoading)
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><Spin size="large" /></div>;
  if (!token) return <Navigate to="/login" replace />;
  return (
    <MenuProvider>
      <AppLayout>{children}</AppLayout>
    </MenuProvider>
  );
}

export default function App() {
  return (
    <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm, token: { colorPrimary: '#ff6b35' } }}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Public menu view — no auth needed */}
            <Route path="/view/:menuId" element={<MenuProvider><PublicMenu /></MenuProvider>} />
            <Route path="/" element={<ProtectedRoute><MenuEditor /></ProtectedRoute>} />
            <Route path="/qr" element={<ProtectedRoute><QRCode /></ProtectedRoute>} />
            <Route path="/preview" element={<ProtectedRoute><PublicMenu /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}
